import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProtectedPaymentRoute = () => {
  const navigate = useNavigate()
  const userToken = localStorage.getItem("transactionId")
  const stripeAccess = localStorage.getItem("stripeAccess")
  useEffect(()=> {
    if(userToken && stripeAccess){
      navigate("/payment")
    }
  }, [userToken, navigate])

};

export default ProtectedPaymentRoute;
